import script from "./StoryCard.vue?vue&type=script&setup=true&lang=js"
export * from "./StoryCard.vue?vue&type=script&setup=true&lang=js"

import "./StoryCard.vue?vue&type=style&index=0&id=4bf4ab4c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4bf4ab4c"]])

export default __exports__